var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var classNames = require("classnames");
var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var ApiClassNames = require("../perseus-api.jsx").ClassNames;
var ApiOptions = require("../perseus-api.jsx").Options;
var InlineIcon = require("../components/inline-icon.jsx");
var styleConstants = require("../styles/constants.js");

var _require2 = require("../icon-paths.js"),
    iconDropdownArrow = _require2.iconDropdownArrow;

var dropdownArrowSize = 24;

var Dropdown = React.createClass({
    displayName: "Dropdown",

    propTypes: {
        apiOptions: ApiOptions.propTypes,
        choices: React.PropTypes.arrayOf(React.PropTypes.string),
        onChange: React.PropTypes.func.isRequired,
        placeholder: React.PropTypes.string,
        selected: React.PropTypes.number,
        trackInteraction: React.PropTypes.func.isRequired
    },

    getDefaultProps: function getDefaultProps() {
        return {
            choices: [],
            selected: 0,
            placeholder: "",
            apiOptions: ApiOptions.defaults
        };
    },

    render: function render() {
        var choices = this.props.choices.slice();

        var selectClasses = classNames({
            "perseus-widget-dropdown": true
        });

        return React.createElement(
            "div",
            null,
            React.createElement(
                "select",
                {
                    onChange: this._handleChangeEvent,
                    onClick: function onClick(e) {
                        e.stopPropagation();
                        e.target.focus();
                    },
                    onTouchStart: function onTouchStart(e) {
                        e.stopPropagation();
                        e.target.focus();
                    },
                    className: selectClasses +
                    // This makes it so that mobile's fastclick doesn't
                    // interfere & call `.focus` when we're inside of a
                    // zoomable table.
                    " nofastclick " + css(styles.dropdown) + " " + ApiClassNames.INTERACTIVE,
                    disabled: this.props.apiOptions.readOnly,
                    value: this.props.selected
                },
                React.createElement(
                    "option",
                    { value: 0, disabled: true },
                    this.props.placeholder
                ),
                choices.map(function (choice, i) {
                    return React.createElement(
                        "option",
                        { key: "" + (i + 1), value: i + 1 },
                        choice
                    );
                })
            ),
            React.createElement(InlineIcon, _extends({}, iconDropdownArrow, {
                style: {
                    marginLeft: "-" + dropdownArrowSize + "px",
                    height: dropdownArrowSize,
                    width: dropdownArrowSize
                }
            }))
        );
    },

    focus: function focus() {
        ReactDOM.findDOMNode(this).focus();
        return true;
    },

    _handleChangeEvent: function _handleChangeEvent(e) {
        this._handleChange(parseInt(e.target.value));
    },

    _handleChange: function _handleChange(selected) {
        this.props.trackInteraction();
        this.props.onChange({ selected: selected });
    },

    getUserInput: function getUserInput() {
        return { value: this.props.selected };
    },

    simpleValidate: function simpleValidate(rubric) {
        return Dropdown.validate(this.getUserInput(), rubric);
    }
});

_.extend(Dropdown, {
    validate: function validate(state, rubric) {
        var selected = state.value;
        if (selected === 0) {
            return {
                type: "invalid",
                message: null
            };
        } else {
            var correct = rubric.choices[selected - 1].correct;
            return {
                type: "points",
                earned: correct ? 1 : 0,
                total: 1,
                message: null
            };
        }
    }
});

var propTransform = function propTransform(editorProps) {
    return {
        placeholder: editorProps.placeholder,
        choices: _.map(editorProps.choices, function (choice) {
            return choice.content;
        })
    };
};

var styles = StyleSheet.create({
    dropdown: {
        appearance: "none",
        backgroundColor: "transparent",
        border: "1px solid " + styleConstants.gray76,
        borderRadius: 4,
        boxShadow: "none",
        fontFamily: styleConstants.baseFontFamily,
        padding: "9px " + (dropdownArrowSize + 1) + "px 9px 9px",

        ":focus": {
            outline: "none",
            border: "2px solid " + styleConstants.kaGreen,
            padding: "8px " + dropdownArrowSize + "px 8px 8px"
        },

        ":focus + svg": {
            color: "" + styleConstants.kaGreen
        },

        ":disabled": {
            color: styleConstants.gray68
        },

        ":disabled + svg": {
            color: styleConstants.gray68
        }
    }
});

module.exports = {
    name: "dropdown",
    displayName: "Drop down",
    defaultAlignment: "inline-block",
    accessible: true,
    widget: Dropdown,
    transform: propTransform
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/dropdown.jsx
 ** module id = 98
 ** module chunks = 0 1
 **/